export default __webpack_public_path__ + "static/media/2495.c3d0da53.png";